import { useState } from "react";
import style from './accordion-item.module.scss'
import AccordionText from "./accordion-text/accordion-text";
import Link from 'next/link';
import { useRouter } from "next/dist/client/router";
import Image from "next/dist/client/image";
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss'

const AccordionItem = (props: any) => {
    let router = useRouter();
    let { state } = props;
    let [opened, setOpened] = useState(false);
    return (

        <>
            <div className={opened ? `${style.item__block} ${style.item__block_opened}` : style.item__block}>
                <Link href={router.asPath} scroll={false}>
                    <a onClick={() => setOpened(!opened)}>
                        <InView triggerOnce={true}>
                            {({ inView, ref, entry }) => {
                                if (inView) {
                                    entry?.target.classList.add(animations.active);
                                }
                                return (
                                    <div ref={ref} className={`${style.item} ${animations.scroll__animation}`}>
                                        <div className={`${style.number__block} ${style.item__number}`}>
                                            {state.id}
                                        </div>
                                        <div className={style.item__block__text}>
                                            <div className={`${style.item__title} ${style.title}`}>
                                                {state.title}
                                            </div>
                                            <div className={style.item__btn}>
                                                <Image alt="accordion-icon" layout={'fill'} src='/wallex-images/ic-plus.svg' />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }}
                        </InView>
                    </a>
                </Link>
                <div className={style.item__text}>
                    {
                        state.text.map((item: any) => {
                            return <AccordionText key={item.id} state={item.text} />
                        })
                    }
                </div>
            </div>
        </>

    )
}


export default AccordionItem;
